import { create_instance } from '../init';

class recentEarnings {
    async getAll() {
        return await create_instance
            .get('/user/recentEarnings')
            .catch(function(error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                } else {
                    // Something happened in setting up the request that triggered an Error
                }
            });
    }
}

export default new recentEarnings();
